
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code1 } from "@/views/resources/documentation/element-ui/basic/layout-container/code";

export default defineComponent({
  name: "common-layouts",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code1
    };
  }
});
